const Header = () => {
    return <></>;
};

export default Header;
